export default __webpack_public_path__ + "static/media/20-Yandex-Black.16c4e285.png";